import { FC } from "react";
import Icons from "src/common/icons";

const NoImages: FC = () => (
  <>
    <Icons.BiGCamera />
  </>
);
export default NoImages;
